import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { AlarisDialogComponent } from '@campaign-portal/components-library';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-import-settings-dialog',
	templateUrl: './dialog.component.html',
	styleUrl: './dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [AlarisDialogComponent, TranslateModule]
})
export class ImportSettingsDialogComponent {

	constructor(
		private readonly dialogRef: DialogRef<boolean>
	) {
	}

	close(): void {
		this.dialogRef.close(false);
	}

	confirm(): void {
		this.dialogRef.close(true);
	}
}
